import { Injectable } from "@angular/core";
import { v4 as uuidv4 } from "uuid";

export interface IWebSocketConfig {
  apiKey: string;
  realtimeHost: string;
  host: string;
}

@Injectable()
export class WebSocketService {
  private socket: WebSocket;

  private authorization = {
    "x-api-key": "",
    realtimeHost: "",
    host: "",
  };

  constructor() {}

  public connect(
    config: IWebSocketConfig,
    onMessage: (message: any) => void
  ): Promise<WebSocket> {
    this.authorization["x-api-key"] = config.apiKey;
    this.authorization["realtimeHost"] = config.realtimeHost;
    this.authorization["host"] = config.host;

    return new Promise((resolve, reject) => {
      this.socket = new WebSocket(
        `wss://${this.authorization["realtimeHost"]}/event/realtime`,
        ["aws-appsync-event-ws", this.getAuthProtocol()]
      );

      this.socket.onopen = () => {
        this.socket.send(JSON.stringify({ type: "connection_init" }));
        resolve(this.socket);
      };
      this.socket.onclose = (evt) => {
        console.log("websocket disconnected");
        reject(evt);
      };
      this.socket.onmessage = (event) => {
        try {
          const msg = JSON.parse(event.data);
          console.log(msg);
          if (msg.type != "ka") {
            onMessage(msg);
          }
        } catch (err) {
          console.error(`Websocket error occurred: ${err}`);
        }
      };
    });
  }

  public disconnect() {
    if (this.socket) {
      this.socket.close();
    }
  }

  public sendMessage(message: any): void {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(message);
    }
  }

  public subscribe(namespace: string, channel: string) {
    this.socket.send(
      JSON.stringify({
        type: "subscribe",
        id: uuidv4(),
        channel: `${namespace}/${channel}`,
        authorization: this.authorization,
      })
    );
  }

  getAuthProtocol() {
    const header = btoa(JSON.stringify(this.authorization))
      .replace(/\+/g, "-") // Convert '+' to '-'
      .replace(/\//g, "_") // Convert '/' to '_'
      .replace(/=+$/, ""); // Remove padding `=`
    return `header-${header}`;
  }
}



// WEBPACK FOOTER //
// ./src/providers/prn-service/socket.ts